<template>
  <div class="page">
    <section class="section primary-header">
      <div class="container is-fluid">
        <h1 class="title is-2">Your Apps</h1>
        <h2 class="subtitle">Connect with apps of your own</h2>
      </div>
    </section>

    <section class="section content-container">
      <n-loading-spinner v-if="isLoading"></n-loading-spinner>
      <div class="container is-fluid" v-show="!isLoading">
        <div class="island">
          <router-view @loaded="loaded()" @loading="loading()"></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { ref } from 'vue';

const isLoading = ref(true);
const loading = () => (isLoading.value = true);
const loaded = () => (isLoading.value = false);
</script>
